import { useField, Field } from 'formik'

import { FloraInput } from '@grupoboticario/flora-react'

export default function FormField({
  name,
  validate,
  disabled,
  invalid,
  invalidText,
  labelText,
  maxLength,
  required,
  rightIcon,
  parser = (value) => value,
  onValueChange = () => {},
  ...props
}) {
  const [field, , { setValue }] = useField({ name, validate })

  return (
    <FloraInput
      {...field}
      as={Field}
      disabled={disabled}
      helperText={invalid ? invalidText : undefined}
      id={name}
      label={labelText}
      maxLength={maxLength}
      name={name}
      onChange={(event) => {
        setValue(parser(event?.target?.value))
        onValueChange(event?.target?.value)
      }}
      required={required}
      {...(rightIcon && { rightIcon })}
      size="medium"
      status={invalid ? 'error' : 'neutral'}
      {...props}
    />
  )
}
